import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/users/user.service';
import { LocationService } from 'src/app/services/locations/location.service';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { BranchService } from 'src/app/services/branches/branch.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit{
  public userId: string | null = null;
  public userData:any;
  roles: any[] = [];
  locations: any[] = [];
  branches: any[] = [];
  public errorMessage: string | null = null;
  invalidLocationSelected: boolean = false;
  isProcessing: boolean = false;
  form!: FormGroup;

  constructor(
    private userService: UserService,
    private locationService: LocationService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private branchService:BranchService,
  ){
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      phone_no: [''],
      email: ['', Validators.required],
      username: ['', [Validators.required,Validators.minLength(6),Validators.maxLength(20)]],
      role_id: ['', Validators.required],
      location_id: ['', Validators.required],
      branch_id: ['', Validators.required],
      stk_access_level: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.userId = param['get']('user_id')
    })

    if(this.userId){
      this.fetchUserData(this.userId);
      this.fetchRoles();
      this.fetchLocations();
    }else{
      //Navigate back to users list with error
      this.globalService.setGlobalErrorMessage("Unable to select user for update!");
      this.router.navigate(['settings/users-list']);
    }
  }

  fetchRoles():void{
    this.userService.getAssignableRoles().subscribe((response: ApiResponse) =>this.roles = response.data);
  }

  fetchLocations():void{
    this.locationService.getAllLocations().subscribe((response: ApiResponse) =>this.locations = response.data);
  }

  fetchBranchesByLocation(locationId: string):void{
    this.branchService.getBranchesByLocation(locationId).subscribe((response: ApiResponse) =>this.branches = response.data);
  }

  //Load branches when location is selected
  onSelectChange(target: EventTarget|null) {
    if (target instanceof HTMLSelectElement) {
      const locationId = target.value;
      
      if(locationId!=='' && locationId!==undefined){
        this.fetchBranchesByLocation(locationId);
      }else{
        this.invalidLocationSelected=true;
      }
     
    }
  }

  /**
   * Get user data
   * @param userId 
   */
  fetchUserData(userId: string): void {
    this.userService.getUserData(userId)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.userData = response;
          if(this.userData.status==='no_data' || this.userData.status.length===0){
            this.errorMessage=this.userData.message;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  handleSubmit():void {
    this.isProcessing = true;

    if (this.form.valid) {
      const formData = {
        ...this.form.value,
      };

      this.userService.updateUser(formData,this.userId).subscribe(response => {
        if(response.status==='success'){

          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);
         
          // Redirect back to users list
          this.router.navigate(['settings/users-list']);
        }else if(response.status==='error'){
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
      this.errorMessage="Please provide all the required details!";
    }
  }

}
